import React from "react";
import { withRouter } from "react-router-dom";
import Formanlist from "./components/Trucklist";
function Truck() {
  return <Formanlist></Formanlist>;
}
export default withRouter(Truck);
